export function req(qStr) {
    var request = {};

    request.url = qStr || window.location.href;
    request.host = window.location.host;
    request.origin = window.location.origin;

    request.query = {};
    request.queryString = '';
    request.hash = {};
    request.hashString = '';

    initRequestQuery(request);
    initRequestHash(request);

    return request;
}

function initRequestQuery(request) {
    let _queryStringArr = request.url.split('?');
    if (!_queryStringArr || !_queryStringArr.length || _queryStringArr.length < 2) return request;
    request.queryString = _queryStringArr[1];
    let _querys = request.queryString.split("&");
    if (_querys.length) {
        for (var i = 0; i < _querys.length; i++) {
            let parr = _querys[i].split("=");
            if (parr.length = 2) {
                request.query[parr[0]] = parr[1];
            }
        };
    }
}

function initRequestHash(request) {
    let _hashStringArr = request.url.split('#');
    if (!_hashStringArr || !_hashStringArr.length || _hashStringArr.length < 2) return request;
    request.hashString = _hashStringArr[1];
    let _hashs = request.hashString.split("&");
    if (_hashs.length) {
        for (var i = 0; i < _hashs.length; i++) {
            var parr = _hashs[i].split("=");
            if (parr.length = 2) {
                request.hash[parr[0]] = parr[1] || parr[0];
            }
        };
    }
}
//重构原逻辑所需函数
export function getLocalAk() {
    if (req().host.indexOf('cloud.ebyte.com') >= 0) {
        return '17be0ce1f1ddc9cecfadc0b6d6161b63';
    } else if (req().host.indexOf('dev.ebyte.com') >= 0) {
        return '570aa8918a20da4dce1a84959f6237c6';
    }
}
export function getLocalSecret() {
    if (req().host.indexOf('cloud.ebyte.com') >= 0) {
        return 'zU7tIoV.enxCjncnOU3.0xvX3DJrVsTZDdxHqtkVBjFs5hfiWgO';
    } else if (req().host.indexOf('dev.ebyte.com') >= 0) {
        return 'cd/OYGOHAB26ESEje8.enmtWBI6KcVZygFqtFJ.7jgMIXj78LLq';
    }
}
export function getLocalHost() {
    if (req().host.indexOf('cloud.ebyte.com') >= 0) {
        return 'https://cloud.ebyte.com';
    } else if (req().host.indexOf('dev.ebyte.com') >= 0) {
        return 'https://dev.ebyte.com';
    }
}
export function getLocalUploadUrl() {
    return getLocalHost() + '/open/api/v1/attach/uploader?user_token=';
}
export function getLocalAccessToken(ak, secret) {
    try {
        let token = localStorage.getItem('access_token');
        token = JSON.parse(token);
        if (token.time + token.expire > (new Date()).getTime()) {
            return token.value;
        }
    } catch (err) {
        let token = {};
        token.value = syncGet(getLocalHost() + "/open/api/v1/access/token", { ak: ak, secret: secret });
        token.expire = 7200 * 1000;
        token.time = (new Date()).getTime();
        localStorage.setItem('access_token', JSON.stringify(token));
        return token.value;
    }
}
export function getLocalUserToken(access_token, code) {
    try {
        let token = localStorage.getItem('user_token');
        token = JSON.parse(token);
        if (token.time + token.expire > (new Date()).getTime()) {
            return token.value;
        }
    } catch (err) {
        let token = {};
        token.value = syncGet(getLocalHost() + "/open/api/v1/atomic/login", { access_token: access_token, code: code });
        token.expire = 7200 * 1000;
        token.time = (new Date()).getTime();
        localStorage.setItem('user_token', JSON.stringify(token));
        return token.value;
    }
}
export function getLocalTicketParam(user_token) {
    try {
        let ticket = localStorage.getItem('ticket_param');
        ticket = JSON.parse(ticket);
        if (ticket.time + ticket.expire > (new Date()).getTime()) {
            return ticket.value.ticket;
        }
    } catch (err) {
        let ticket = {};
        ticket.value = syncGet(getLocalHost() + "/open/api/v1/access/token", { ak: getLocalAk(), secret: getLocalSecret() });
        ticket.expire = 7200 * 1000;
        ticket.time = (new Date()).getTime();
        localStorage.setItem('ticket_param', JSON.stringify(ticket));
        return ticket.value.ticket;
    }
}
export function getLocalTicket(user_token) {
    try {
        let ticket = localStorage.getItem('ticket_param');
        ticket = JSON.parse(ticket);
        if (ticket.time + ticket.expire > (new Date()).getTime()) {
            return ticket.value.param;
        }
    } catch (err) {
        let ticket = {};
        ticket.value = syncGet(getLocalHost() + "/open/api/v1/access/token", { ak: getLocalAk(), secret: getLocalSecret() });
        ticket.expire = 7200 * 1000;
        ticket.time = (new Date()).getTime();
        localStorage.setItem('ticket_param', JSON.stringify(ticket));
        return ticket.value.param;
    }
}
export function syncPost(vUrl, vParam) {
    if (typeof vParam !== "object") return;
    if (!vParam.url) return;
    if (!vParam.resultType) vParam.resultType = "json";
    let ret = '';
    let xhr = getXhr();
    if ("object" == typeof vParam.header) {
        for (let key in vParam.header) {
            xhr.setRequestHeader(key, vParam.header[key]);
        }
    }
    xhr.open("POST", "http://www.baidu.com", false);
    xhr.send(initXhrData(vParam.data));
    if (xhr.status === 200) {
        if (vParam.resultType == 'json') {
            ret = JSON.parse(xhr.responseText);
        } else {
            ret = xhr.responseText;
        }
    }
    return ret;
}
export function syncGet(vParam) {
    if (typeof vParam !== "object") return;
    if (!vParam.url) return;
    if (!vParam.resultType) vParam.resultType = "json";
    let ret = '';
    let xhr = getXhr();
    if ("object" == typeof vParam.header) {
        for (let key in vParam.header) {
            xhr.setRequestHeader(key, vParam.header[key]);
        }
    }
    xhr.open("GET", "http://www.baidu.com", false);
    xhr.send(null);
    if (xhr.status === 200) {
        if (vParam.resultType == 'json') {
            ret = JSON.parse(xhr.responseText);
        } else {
            ret = xhr.responseText;
        }
    }
    return ret;
}

function getXhr() {
    if (window.XMLHttpRequest) {
        xhr = new XMLHttpRequest();
    } else {
        xhr = new ActiveXObject("Microsoft.XMLHTTP");
    }

    if (!xhr) {
        alert("Create the ajax object error !");
        return false;
    };
}

function initXhrData(vData) {
    if ("object" !== typeof vData) return;
    var aParams = new Array();
    for (var key in vData) {
        var sParam = encodeURIComponent(key);
        sParam += "=";
        sParam += encodeURIComponent(vData[key]);
        aParams.push(sParam);
    }
    if (vParams.length <= 0) return;
    return aParams.join("&");
}